import { DEFAULT_ALLOWED_PHONE_NUMBER_COUNTRIES, buildInvalidPhoneNumberLabel, parseAllowedPhoneNumber, } from 'notable-common';
import { z } from 'zod';
import { FlowBlockValueStringSchema } from './stringSchema.js';
/**
 * A Zod schema for validating phone numbers with configurable country allowlists. The function name
 * retains "Us" for backward compatibility and stable imports despite accepting non-US numbers when
 * configured via `allowedCountries`.
 *
 * @arg isRequired - if isRequired is false, the empty string is allowed. Chain the schema with .optional() if
 * the entire config property is optional.
 * @arg allowedCountries - country codes the value is allowed to belong to. Defaults to US-only.
 * @returns A Zod schema for validating values that are either block value templates or a phone number string
 *   belonging to one of the allowed countries.
 */
export function FlowBlockValueUsPhoneNumberSchema(args) {
    const { isRequired = false, allowedCountries = DEFAULT_ALLOWED_PHONE_NUMBER_COUNTRIES } = args;
    const errorMessage = `${buildInvalidPhoneNumberLabel(allowedCountries)}.`;
    const blockValueOrPhoneNumberSchema = FlowBlockValueStringSchema({
        stringValidationSchema: z.string().superRefine((value, context) => {
            if (!parseAllowedPhoneNumber({ value, allowedCountryCodes: allowedCountries })) {
                context.addIssue({
                    code: 'custom',
                    message: errorMessage,
                });
            }
        }),
    });
    if (isRequired) {
        return blockValueOrPhoneNumberSchema;
    }
    return z.union([z.literal(''), blockValueOrPhoneNumberSchema]);
}
//# sourceMappingURL=phoneNumberSchema.js.map